import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { localStorageConstants } from '../../../consts/local_storage_constants';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser$: Observable<any>;

    private roleSubject = new BehaviorSubject<string>('guest'); // default
    role$ = this.roleSubject.asObservable();


    constructor(private router: Router) {
        const userData = localStorage.getItem(localStorageConstants.SUPER_ADMIN_DATA) ||
            localStorage.getItem(localStorageConstants.USER_DATA);
        this.currentUserSubject = new BehaviorSubject<any>(userData ? JSON.parse(userData) : null);
        this.currentUser$ = this.currentUserSubject.asObservable();
    }

    setRole(role: string) {
        this.roleSubject.next(role);
    }

    get currentRole(): string {
        return this.roleSubject.value;
    }

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }

    public isSuperAdminLoggedIn(): boolean {
        return !!localStorage.getItem(localStorageConstants.SUPER_ADMIN_TOKEN);
    }

    public isPortalUserLoggedIn(): boolean {
        return !!localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
    }

    public isLoggedIn(): boolean {
        return this.isSuperAdminLoggedIn() || this.isPortalUserLoggedIn();
    }

    public getUserType(): string | null {
        if (this.isSuperAdminLoggedIn()) return 'superadmin';
        if (this.isPortalUserLoggedIn()) return 'portal';
        return null;
    }

    superAdminLogout(): void {
        localStorage.removeItem(localStorageConstants.SUPER_ADMIN_TOKEN);
        localStorage.removeItem(localStorageConstants.SUPER_ADMIN_DATA);
        localStorage.setItem(localStorageConstants.SUPER_ADMIN_LOGGED_IN, 'false');
        this.currentUserSubject.next(null);
        this.router.navigate(['/superadmin/login']);
    }

    portalLogout(): void {
        localStorage.removeItem(localStorageConstants.PORTAL_TOKEN);
        localStorage.removeItem(localStorageConstants.USER_DATA);
        localStorage.setItem(localStorageConstants.PORTAL_LOGGED_IN, 'false');
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
    }

    logout(): void {
        if (this.isSuperAdminLoggedIn()) {
            this.superAdminLogout();
        } else if (this.isPortalUserLoggedIn()) {
            this.portalLogout();
        }
    }


}